<template>
  <div class="container-attributes">
    <header v-test:header="rateAttribute.name">
      <h3>{{ rateAttribute.name }}</h3>
      <p><span>Rate Basis</span>: {{ rateBasis }}</p>
    </header>
    <rates-table
      v-if="rateAttribute.products[0].tier_group"
      :rate-attribute="rateAttribute"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import RatesTable from './Table';

  /**
   * A styled component used for each attribute prop to display the name, rate basis, and the rate values table.
   *
   * @vuedoc
   * @exports Rates/Attribute
   * @category Components
   */
  export default {
    name: 'RatesAttribute',
    components: { RatesTable },
    props: {
      rateAttribute: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState('rateAttributes', ['isPlanBased']),
      /**
       * Get the formatted rate basis for the appropriate subtype value.
       *
       * @returns {string}
       */
      rateBasis() {
        const [subtypes] = this.rateAttribute.products[0].tier_group.tier_subtypes;
        const attributeInfo = this.isPlanBased
          ? subtypes.rate_value
          : subtypes.rate_values[0];

        return attributeInfo.formatted_rate_basis;
      },
    },
  };
</script>

<style lang="scss" scoped>
  header {
    padding: 20px;
    border: 1px solid $tf-light-gray;
    border: {
      top: none;
      bottom: none;
    }
  }

  span {
    font-weight: 700;
  }
</style>
